import React from 'react'

import type { BreadcrumbsProps } from './types'
import Anchor from '../anchor/Anchor'

const Breadcrumbs: React.FunctionComponent<BreadcrumbsProps> = ({
  children,
  items,
  separator = '•',
  className = 'breadcrumb',
  ...rest
}) => {
  return (
    <nav className={className} aria-label="Breadcrumb" {...rest}>
      <ol className="breadcrumb__list">
        {items && items.length > 0
          ? items.map((item, index) => (
              <React.Fragment key={index}>
                <li className="breadcrumb__item">
                  {item.anchor ? (
                    <Anchor {...item.anchor} />
                  ) : (
                    <>{item.title}</>
                  )}
                </li>
                {index < items.length - 1 && (
                  <li className="breadcrumb__separator" aria-hidden="true">
                    {separator}
                  </li>
                )}
              </React.Fragment>
            ))
          : React.Children.map(children, (child, index) => (
              <React.Fragment key={index}>
                {child}
                {React.Children.count(children) > index + 1 ? (
                  <li className="breadcrumb__separator" aria-hidden="true">
                    {separator}
                  </li>
                ) : null}
              </React.Fragment>
            ))}
      </ol>
    </nav>
  )
}

export default Breadcrumbs
